// Store home: breadcrumb, hero, grid of category cards

import { Link } from 'react-router-dom';
import { useCategories } from '@/hooks/use-store';
import { StoreBreadcrumbs } from '@/components/store/StoreBreadcrumbs';
import SEO from '@/components/SEO';
import { sitePath } from '@/lib/site-config';
import { toAbsoluteImageUrl } from '@/lib/store-images';
import { Card, CardHeader } from '@/components/ui/card';
import { StoreCardDescription } from '@/components/store/StoreCardDescription';
import { Skeleton } from '@/components/ui/skeleton';

const StoreHome = () => {
  const { data: categories, isLoading } = useCategories();
  // OG image: first category with cover, or default site image for link previews
  const storeOgImage = categories?.find((c) => c.cover_image)?.cover_image;
  const storeOgImageAbsolute = toAbsoluteImageUrl(storeOgImage);

  return (
    <div className="space-y-6">
      <SEO
        title="Tienda B2B | Padmora"
        description="Catálogo de productos B2B. Navega por categorías, consulta familias y solicita cotizaciones en Padmora."
        canonical={sitePath('/store')}
        image={storeOgImageAbsolute ?? undefined}
        breadcrumbs={[{ name: 'Store', url: sitePath('/store') }]}
      />
      <StoreBreadcrumbs segments={[{ label: 'Store' }]} />
      <div>
        <h1 className="text-3xl font-bold text-zinc-900 tracking-tight">Procurement Store</h1>
        <p className="mt-2 text-zinc-600 max-w-xl">Browse categories and request quotations for physical products.</p>
      </div>
      {isLoading ? (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-40 rounded-lg" />
          ))}
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(categories ?? []).map((cat) => (
            <Link key={cat.id} to={`/store/category/${cat.slug}`} className="group block min-w-0">
              <Card className="h-full min-w-0 overflow-hidden transition-shadow hover:shadow-md border-zinc-200 flex flex-col">
                {cat.cover_image && (
                  <div className="aspect-video w-full overflow-hidden rounded-t-lg bg-zinc-100">
                    <img src={cat.cover_image} alt="" className="h-full w-full object-cover group-hover:scale-[1.02] transition-transform duration-200" loading="lazy" />
                  </div>
                )}
                <CardHeader className="font-semibold text-zinc-900 min-w-0">{cat.name}</CardHeader>
                {cat.description && (
                  <StoreCardDescription
                    wrapperClassName="px-6 pb-6 pt-0"
                    className="text-sm text-zinc-600"
                  >
                    {cat.description}
                  </StoreCardDescription>
                )}
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default StoreHome;
